import {
  API_GET_TAXES_ALL,
  API_GET_TAXES_BY_STORE_ID,
  API_POST_DELATE_TAX,
  API_POST_UPSERT_TAX,
} from 'common/constants/apis';
import UILogger from 'common/utils/logger';
import httpClient from './config';
import {DEFAULT_RETRY_CONFIG} from 'common/constants';
import {AxiosRequestConfig} from 'axios';
import {IGetAllTaxResp, ITax, ITaxResp} from 'common/interfaces/istore';
import {ServerResponse} from 'common/interfaces';

export const getTaxByStoreId = async (storeId: number): Promise<ITaxResp> => {
  UILogger.info('Sending get tax by storeId:', storeId);
  let url = API_GET_TAXES_BY_STORE_ID;

  url = url?.replace('{storeId}', storeId.toString());
  UILogger.info('Sending tax by storeId. url:', url);
  return httpClient
    .get(url, DEFAULT_RETRY_CONFIG as AxiosRequestConfig)
    .then(res => {
      UILogger.log('GET tax by storeId response: ', res.data);
      return res.data;
    })
    .catch(error => {
      console.log(
        'Error in getting tax by storeId entry: ',
        error.response.data,
        'by id::',
        storeId,
      );
      return error.response.data;
    });
};

/**
 *
 * @returns for master admin
 */
export const getAllTaxes = async (): Promise<IGetAllTaxResp> => {
  let url = API_GET_TAXES_ALL;
  UILogger.info('Getting all the taxes. ', API_GET_TAXES_ALL);
  return httpClient
    .get(url, DEFAULT_RETRY_CONFIG as AxiosRequestConfig)
    .then(res => {
      UILogger.log('GET tax by storeId response: ', res.data);
      return res.data;
    })
    .catch(error => {
      console.log('Error in getting taxes: ', error.response.data);
      return error.response.data;
    });
};

export const postUpdateTax = (payload: ITax): Promise<ITaxResp> => {
  UILogger.info('Sending update tax request', payload);
  return httpClient
    .post(
      API_POST_UPSERT_TAX,
      payload,
      DEFAULT_RETRY_CONFIG as AxiosRequestConfig,
    )
    .then(res => {
      UILogger.log('add tax response: ', res.data);
      return res.data;
    })
    .catch(error => {
      console.log('Error upserting tax:::', error.response.data);
      return error.response.data;
    });
};

export const postDeleteTax = (taxId: number): Promise<ServerResponse> => {
  UILogger.info('Sending deleter tax request for tax: ', taxId);
  return httpClient
    .delete(
      API_POST_DELATE_TAX.replace('{taxId}', taxId.toString()),
      DEFAULT_RETRY_CONFIG as AxiosRequestConfig,
    )
    .then(res => {
      UILogger.log('delete tax response: ', res.data);
      return res.data;
    })
    .catch(error => {
      console.log('Error deleting tax:::', error.response.data);
      return error.response.data;
    });
};
